import { render, staticRenderFns } from "./chooseTemplate.vue?vue&type=template&id=4b422708"
import script from "./chooseTemplate.vue?vue&type=script&lang=js"
export * from "./chooseTemplate.vue?vue&type=script&lang=js"
import style0 from "./chooseTemplate.vue?vue&type=style&index=0&id=4b422708&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../fe-workerportal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports